var $e587cc83dacd6e22$exports = {};
const $e587cc83dacd6e22$var$clientId = "fappen";
const $e587cc83dacd6e22$var$tokenAuthEndpoint = "http://127.0.0.1:8000/o/token/";
async function $e587cc83dacd6e22$var$handleCallback() {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const returnedState = params.get("state");
    // No OIDC callback → do nothing, silently
    if (!code || !returnedState) return;
    const expectedState = sessionStorage.getItem("oidc_state");
    const verifier = sessionStorage.getItem("pkce_verifier");
    // Cleanup early to avoid replay issues
    sessionStorage.removeItem("oidc_state");
    sessionStorage.removeItem("pkce_verifier");
    // Hard failure, but still non-intrusive
    if (!expectedState || returnedState !== expectedState || !verifier) {
        console.warn("OIDC callback validation failed");
        return;
    }
    let response;
    try {
        response = await fetch($e587cc83dacd6e22$var$tokenAuthEndpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: new URLSearchParams({
                client_id: $e587cc83dacd6e22$var$clientId,
                grant_type: "authorization_code",
                code: code,
                code_verifier: verifier,
                redirect_uri: window.location.origin + window.location.pathname
            })
        });
    } catch (err) {
        console.warn("Token request failed", err);
        return;
    }
    if (!response.ok) {
        console.warn("Token endpoint returned error", response.status);
        return;
    }
    const tokenResponse = await response.json();
    // At this point auth succeeded — you decide what “login” means
    console.log("OIDC token response:", tokenResponse);
    // Optional: clean URL (no reload)
    window.history.replaceState({}, document.title, window.location.pathname);
}
// Safe to call on every page load
$e587cc83dacd6e22$var$handleCallback();


//# sourceMappingURL=pages.6fe07fda.js.map
